import React from 'react'

const ImageContainer = ({ children }) => {
    return (
        <div className="col-xs-12 col-md-9">
            <div className="interlude-wrapper">
                {children}
            </div>
        </div>
    )
}

export default ImageContainer
